import getCharts from '../getCharts'
import { HolidayCalendarCRUD } from '../../constants/api.config'
import { formatValueToMMDDYYYY } from '../../components/shared/customDateFormatUtils'

export default async function SaveHoliday(params = {}) {
  let payload = {}
  const normalizeDate = (value) => formatValueToMMDDYYYY(value) || value || ''

  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const mode = String(params.mode || '').toUpperCase()
    const holidayData = {
      country: params.country,
      year: params.year,
      isActive: params.isActive ?? true,
    }

    if (mode === 'INSERT' || mode === 'UPDATE') {
      holidayData.date = normalizeDate(params.date)
      holidayData.name = params.name
    }

    payload = {
      mode,
      holidayId: params.holidayId || null,
      holidayData: JSON.stringify(holidayData),
    }
  }

  try {
    const res = await getCharts(HolidayCalendarCRUD, payload)
    return res.data
  } catch (error) {
    console.error('SaveHoliday API failed:', error)
    return error
  }
}
